(function () {
    'use strict';
    var controllerId = 'contoCorrente';
    angular.module('app').controller(controllerId, ['$rootScope', 'common', 'bootstrap.dialog', '$filter','$routeParams', '$uibModal', 'datacontext', 'sectionMenu', contoCorrente]);

    function contoCorrente($rootScope, common, bDialog, $filter, $routeParams, $uibModal, datacontext, sectionMenu) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard

        var vm = this;
        vm.title = 'Conti Correnti';
        vm.view = 'list';       //Opzione list or detail
        vm.setView = setView;
        vm.sectionMenu = sectionMenu.setSection(vm.title);

        //Gestione sola lettura
        vm.readOnly = !$rootScope.isAuthorized('SUPER');
        vm.super = $rootScope.isAuthorized('SUPER');

        vm.objName = "sede"; //Utilizzato per pannello modale
        vm.showObjPanel = false;
        vm.record = {};
        vm.records = [];
        vm.countRecords = 0;
        vm.index = 0;
        vm.custom = false;

        vm.page = 1;
        vm.loading = false;
        vm.addDisabled = vm.readOnly;
        vm.exportDisabled = false;
        vm.pageSize = 30;
        vm.page = 1;
        vm.loading = false;

        //Elenchi dettaglio
        vm.list = {};
        vm.list.ordine = ['beneficiario', 'banca', 'agenzia', 'IBAN'];
        vm.ordine = vm.list.ordine[3];
        vm.selectOrdine = function (item) {
            vm.ordine = item;
            vm.cerca();
        };
        vm.list.classi = [];

        //Filtro
        vm.filter = {};
        vm.filter.nome = ' ';        

        //Metodi su interfaccia
        vm.cerca = cerca;
        vm.loadMore = getAllByFilter;
        vm.loadAll = getAll;

        vm.get = getRecord;
        vm.add = addModal;
        vm.update = updateItem;
        vm.delete = deleteItem;

        // ---- ACTIVATE -------
        activate();

        function activate() {
            var promises = [];
            common.activateController(promises, controllerId)
                    .then(function () {
                        if ($routeParams.ListinoId != null) {
                            setView('detail');
                            getRecord($routeParams.ListinoId, 0);                            
                        }
                    });
        }

        //****************************************************
        // METODI 
        //****************************************************
        function setView(view) {
            return vm.view = view;
        }

        function cerca() {
            vm.records = [];
            vm.countRecords = 0;
            vm.page = 1;
            vm.filter.nome = vm.fNome == null ? '' : vm.fNome;

            vm.loading = false;
            countByFilter();
            return getAllByFilter();
        }

        function countByFilter() {
            return datacontext.contoCorrente_countAll().then(function (data) {
                if (data) {
                    vm.countRecords = data;
                }
            });
        }

        function getAllByFilter() {
            if (vm.loading === true) return;

            if (vm.countRecords == 0) countByFilter();
            else if (vm.countRecords <= vm.records.length) return;

            vm.loading = true;
            return datacontext.contoCorrente_getAll(vm.pageSize, vm.page, vm.ordine).then(function (data) {
                if (data.constructor === Array) {
                    vm.page++;
                    data.forEach(function (item) {
                        vm.records.push(item);
                    });
                }
                vm.loading = false;
            });
        }

        function getAll() {
            if (vm.records.length < vm.countRecords) {
                getAllByFilter().then(function () { getAll(); });
            }
        }

        function getRecord(id, index) {
            return datacontext.contoCorrente_get(id).then(function (data) {
                vm.index = index;
                vm.record = data;
                setView('detail');
            });
        }        

        function addRecord(id) {
            return datacontext.contoCorrente_get(id).then(function (data) {
                vm.records.push(data);
                vm.countRecords++;
            });
        }

        function updateItem() {
            return datacontext.contoCorrente_update(vm.record).then(function (data) {
                vm.records[vm.index] = data;
                logSuccess('Dato salvato ');
            });
        }


        function deleteItem(item) {
            var msg = ' il conto corrente ' + item.CC;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.contoCorrente_delete(item.Id).then(function (data) {
                    if (data != "204") return logError('Errore durante la rimozione del dato');
                    var index = vm.records.indexOf(item)
                    vm.records.splice(index, 1);
                    vm.countRecords--;
                });
            });
        }

        //****************************************************
        // OPEN MODAL DIALOG
        //****************************************************
        function addModal() {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/contoCorrente/modal/contoCorrenteAdd.html?version=43',
                controller: 'contoCorrenteAdd',
                resolve: {
                    
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem) return logError('Errore durante la creazione del dato ');

                logSuccess('Record creato con successo ');
                addRecord(returnItem.Id);
            });
        };
    }
})();
